import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { createGlobalStyle } from '../../components/global-styles.js';
import { fontStack, printFontFace } from '../utils.js';
import { SBonus } from '../SBonus/index.js';

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var weights = {
  bold: 700
};
var Joe182 = _objectSpread(_objectSpread({}, SBonus), {}, {
  fontFamily: fontStack(['Joe182', 'Roboto', 'Arial', 'sans-serif']),
  defaultWeight: 700,
  weights: weights,
  CSS: createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), printFontFace('Joe182', weights.bold, 'normal', 'Joe182-regular'))
});

export { Joe182 };
//# sourceMappingURL=index.js.map
